import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents'
import CardExpansion from '@ifca-root/react-component/src/components/CardList/CardExpansion'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import { Checkbox, FormControlLabel, ListItem } from '@material-ui/core'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  GetWarehouseDocument,
  useAssignWarehouseItemMutation,
  useGetCompanyQuery,
  useGetWarehouseQuery,
  useUnassignWarehouseItemMutation,
} from 'generated/graphql'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useMediaQuery } from '@material-ui/core'
import theme from '@ifca-root/react-component/src/assets/theme'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
interface AvailableStockItemProps {
  StockItemID: String
}

export const AvailableStockItemForm = (props: any) => {
  let history = useHistory()
  let location = useLocation()
  const CompanyID: any = location?.state
  const { WarehouseID }: any = useParams()
  const [entity, setEntity] = useState<Set<any>>()
  const isDesktop = useMediaQuery(theme.breakpoints.up('sm'), {
    defaultMatches: true,
  })

  let user = JSON.parse(localStorage.getItem('loggedInUser'))
  const { handlePermDisabled } = usePermissionChecker()

  const {
    pageMode,
    filteredList,
    handleSearch,
    fetchStockCategory,
  }: any = props
  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )
  const [expandArray, setExpandArray] = useState([])

  const {
    handleSubmit,
    register,
    setValue,
    control,
    errors,
    watch,
    reset,
    setError,
    getValues,
    formState,
  } = useForm<AvailableStockItemProps>({
    defaultValues: {},
    mode: 'all',
  })

  const [
    assignWarehouseItem,
    {
      loading: assignWarehouseItemLoading,
      error: assignWarehouseItemError,
      data: assignedWarehouseData,
    },
  ] = useAssignWarehouseItemMutation({
    onError: error => {
      console.log('ERROR', error)
    },
    onCompleted: data => {
      fetchStockCategory({
        variables: {
          WarehouseID: WarehouseID,
          mode: pageMode,
        },
      })
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setTimeout(() => {
        setEntity(new Set(undefined))
        history.push({
          // pathname: `/general-ledger/general-setting/master-coa/${accType}`,
          state: CompanyID,
        })
      }, 500)
    },
  })
  const [
    unassignWarehouseItem,
    {
      loading: unassignWarehouseItemLoading,
      error: unassignWarehouseItemError,
      data: unassignedWarehouseData,
    },
  ] = useUnassignWarehouseItemMutation({
    onError: error => {
      console.log('ERROR', error)
    },
    onCompleted: data => {
      fetchStockCategory({
        variables: {
          WarehouseID: WarehouseID,
          mode: pageMode,
        },
      })
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setEntity(new Set(undefined))
      setTimeout(() => {
        history.push({
          // pathname: `/general-ledger/general-setting/master-coa/${accType}`,
          state: CompanyID,
        })
      }, 500)
    },
  })
  /* -------------------------------------------- */
  /*                   FUNCTION                   */
  /* -------------------------------------------- */

  const handleCreateUpdate =
    pageMode === 'available' ? assignWarehouseItem : unassignWarehouseItem

  // handle checkbox for specific stock item
  const handleCheckBoxChange = (e: any, data: any, index: number) => {
    let entityTemp = entity || new Set()
    if (!entityTemp.has(e.target.value)) {
      data?.StockItem?.find(v => {
        if (v.StockItemID === e.target.value) {
          entityTemp.add(v?.StockItemID)
        }
      })
    } else {
      data?.StockItem?.find(v => {
        if (v.StockItemID === e.target.value) {
          entityTemp.delete(v?.StockItemID)
        }
      })
    }
    setEntity(new Set(entityTemp))
  }

  // handle checkbox for specific stock item
  const handleSelectCategory = (e: any, data: any, index: number) => {
    let entityTemp = entity || new Set()
    if (!e.target.checked) {
      data?.StockItem?.map(x => {
        entityTemp.delete(x?.StockItemID)
      })
    } else {
      data?.StockItem?.map(x => {
        entityTemp.add(x?.StockItemID)
      })
    }
    setEntity(new Set(entityTemp))
  }

  // handle checkbox for all
  const handleSelectAll = (e: any) => {
    let temp = entity || new Set()
    if (!e?.target?.checked) {
      temp.clear()
    } else {
      filteredList?.map(el => {
        el?.StockItem.forEach(v => {
          if (pageMode === 'assigned') {
            if (!v?.isUsed) {
              temp.add(v?.StockItemID) // Only add non-disabled items
            }
          } else temp.add(v?.StockItemID) //
        })
      })
    }
    setEntity(new Set(temp))
  }

  //to get stockItemID in stock category
  const listOfItemIds = () => {
    let ids = []
    filteredList?.map(x => {
      x?.StockItem?.map(el => {
        if (!el?.isUsed) ids.push(el?.StockItemID)
      })
    })
    return ids
  }

  let listCheckedEntity: any = Array.from(entity || [])

  const assignOption = {
    name: 'Assign',
    onClick: () => {
      handleSubmit(onSubmit)()
    },
    color: 'primary',
    disabled:
      !user?.superUser &&
      handlePermDisabled({
        permEnum:
          AcctPermission.InventoryControlGeneralSettingsWarehouseAssignItem,
      }),
  }
  const unassignOption = {
    name: 'Unassign',
    onClick: () => {
      handleSubmit(onSubmit)()
    },
    color: 'primary',
    disabled:
      !user?.superUser &&
      handlePermDisabled({
        permEnum:
          AcctPermission.InventoryControlGeneralSettingsWarehouseAssignItem,
      }),
  }

  const submitOption: any[] =
    pageMode === 'available' ? [assignOption] : [unassignOption]
  const onSubmit = data => {
    handleCreateUpdate({
      variables: {
        input: {
          CompanyID: CompanyID,
          WarehouseID: WarehouseID,
          stockItemID: listCheckedEntity,
        },
      },
      refetchQueries: [
        {
          query: GetWarehouseDocument,
          variables: { WarehouseID: WarehouseID },
        },
      ],
    })
  }

  return (
    <>
      {assignWarehouseItemLoading && <Loading />}
      {unassignWarehouseItemLoading && <Loading />}

      {/* <SnackBarMsg open={msg} message={MESSAGE} /> */}
      <SearchHeader
        title="Search here.."
        value={`${filteredList?.reduce((a, b) => a + b.StockItem?.length, 0) ||
          0}`}
        search
        onChangeAction={e => {
          handleSearch(e?.target?.value, ['Name', 'StockItem.Name'])
        }}
        onCloseAction={() => handleSearch('', [])}
        multiDynamicSubInfo
        style={{ marginTop: '20px' }}
      />

      <ContentWrapper float style={{ marginTop: isDesktop ? '40px' : '120px' }}>
        {filteredList?.length === 0 ? (
          <EmptyList
            title={`No ${
              pageMode === 'available' ? 'available' : 'assigned'
            } item`}
          />
        ) : (
          <>
            <ListItem style={{ padding: '0px 16px' }}>
              <FormControlLabel
                className="select-all-font"
                control={
                  <Checkbox
                    color="primary"
                    onChange={e => {
                      handleSelectAll(e)
                    }}
                    checked={listOfItemIds().every(
                      el => !!listCheckedEntity.includes(el)
                    )}
                  />
                }
                label={<span className="xsTitle flex-space">Select All</span>}
                style={{ paddingLeft: '7px' }}
              />
            </ListItem>
            <CardContents>
              <div style={{ width: '100%' }}>
                {filteredList
                  ?.sort((a, b) => {
                    return a.Name.localeCompare(b.Name)
                  })
                  .map((v, index) => {
                    return (
                      <div>
                        <CardExpansion
                          summary={
                            <>
                              <Checkbox
                                color="primary"
                                value={v.StockItemID}
                                onChange={e => {
                                  handleSelectCategory(e, v, index)
                                }}
                                onClick={e => e.stopPropagation()}
                                disabled={
                                  pageMode === 'assigned'
                                    ? !!v?.StockItem.find(
                                        (el: any) => el?.isUsed
                                      )
                                      ? true
                                      : false
                                    : false
                                }
                                checked={
                                  !!v?.StockItem.find(
                                    (el: any) =>
                                      !listCheckedEntity.includes(
                                        el?.StockItemID
                                      )
                                  )
                                    ? false
                                    : true
                                }
                              />
                              <span className="xsTitle text-noflow">
                                {v.Name}
                              </span>
                            </>
                          }
                        >
                          <div>
                            {v?.StockItem?.map(y => (
                              <div>
                                <Checkbox
                                  color="primary"
                                  value={y.StockItemID}
                                  onChange={e => {
                                    handleCheckBoxChange(e, v, index)
                                  }}
                                  disabled={
                                    pageMode === 'assigned' ? y?.isUsed : false
                                  }
                                  checked={
                                    pageMode === 'assigned'
                                      ? (!!listCheckedEntity.find(
                                          (el: any) =>
                                            el.StockItemID === y.StockItemID
                                        ) &&
                                          !y?.isUse) ||
                                        (listCheckedEntity.includes(
                                          y?.StockItemID
                                        ) &&
                                          !y?.isUsed) ||
                                        (entity?.size ===
                                          filteredList?.length &&
                                          !y?.isUse)
                                      : !!listCheckedEntity.find(
                                          (el: any) =>
                                            el.StockItemID === y.StockItemID
                                        ) ||
                                        listCheckedEntity.includes(
                                          y?.StockItemID
                                        ) ||
                                        entity?.size === filteredList?.length
                                  }
                                />
                                <span className="xsTitle text-noflow">
                                  {y?.Name}
                                </span>
                              </div>
                            ))}
                          </div>
                        </CardExpansion>
                      </div>
                    )
                  })}
              </div>
            </CardContents>
          </>
        )}
      </ContentWrapper>
      <Footer options={[...submitOption]} />
    </>
  )
}
